import { render } from "./EditConnection.vue?vue&type=template&id=3b6e99c7"
import script from "./EditConnection.vue?vue&type=script&lang=js"
export * from "./EditConnection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__